import React from "react";
import R from "ramda";
import styled from "styled-components";
import { compose, lifecycle, withState, withHandlers, withPropsOnChange, } from "recompose";
import { connect, } from "react-redux";

import * as m from "src/components/style/mixins";
import * as v from "src/components/style/vars";
import * as consts from "src/consts";
import { plog, } from "src/lib/util";

import {
	GridCell,
	Button,
	cloneAllProps,
	Main,
	delay,
} from "src/components/common";

import GalleryImage from "./GalleryImage";
import Topbar from "src/components/Editor/Topbar";

// --------------------------------------------------

const Inner = styled(GridCell)`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
`;

const GalleryImageWrapper = styled(GridCell)`
	width: 400px;
`;

// --------------------------------------------------


const enhance = compose(
	connect(R.identity),
	withPropsOnChange([ "match", ], R.path([ "match", "params", ])),
	withState("entriesObj", "setEntriesObj", {}),
	withPropsOnChange([ "entriesObj", ], ({ entriesObj, }) => ({
		entriesList: Object.values(entriesObj),
	})),
	withState("loading", "setLoading", false),
	withHandlers({
		setEntry: ({ setEntriesObj, }) => entry => {
			setEntriesObj(obj => {
				const oldEntry = obj[entry.sys.id];
				const newEntry = cloneAllProps(oldEntry);
				newEntry.fields = entry.fields;
				newEntry.changed = true;
				obj[entry.sys.id] = newEntry;
				return { ...obj };
			});
		},
		getData: props => () => {
			console.log(props);
			props.setLoading(true)
			const filter = R.pipe(
				R.when(R.always(props.tag), R.assoc("fields.tags", props.tag)),
				R.when(R.always(props.hash), R.assoc("fields.uploadHash", props.hash)),
			)({});
			props.space.getEntries({
				"content_type": "gallery-image",
				...filter,
			})
			.then(entries => {
				console.log("entries", entries);
				const entriesObj = entries.items.reduce((acc, entry) => ({
					...acc,
					[entry.sys.id]: entry,
				}), {});
				props.setEntriesObj(entriesObj);
				props.setLoading(false)
			});
		},
		updateAll: ({ entriesList, }) => () => {

			return Promise.all(entriesList.map(entry => {
				if (entry.changed) {
					delete entry.changed;
					return (
						entry.update()
						.then(entry => entry.publish())
					);
				}
				else {
					return Promise.resolve();
				}
			}))

			// return entriesList.reduce((p, entry) => (
			// 	p.then(() => {					
			// 		if (entry.changed) {
			// 			delete entry.changed;
			// 			return (
			// 				entry.update()
			// 				.then(entry => entry.publish())
			// 			);
			// 		}
			// 		else {
			// 			return Promise.resolve();
			// 		}
			// 	})
				
			// ), Promise.resolve());
		},
	}),
	lifecycle({
		componentDidMount() {
			this.props.getData();	
		},
		componentDidUpdate (prevProps) {
			if (
				this.props.hash !== prevProps.hash ||
				this.props.tag !== prevProps.tag
			) {
				this.props.getData()
			}
		}
	}),	
);

const Comp = ({
	entriesList,
	setEntry,
	updateAll,
	loading
}) => (
	<div>
		<Topbar
			title = "Gallery Images"
			save = { updateAll }
		>
		</Topbar>
		<Main>
			<Inner>
			{
				loading
				? <div>Loading...</div>
				: entriesList.map(entry => (
					<GalleryImageWrapper key = { entry.sys.id }>
						<GalleryImage entry = { entry } setEntry = { setEntry }/>
					</GalleryImageWrapper>
				))
			}
			</Inner>
		</Main>
	</div>
);

export default enhance(Comp);














// WEBPACK FOOTER //
// ./src/components/Editor/Images/GalleryImages.js